import { render, staticRenderFns } from "./TitleDeedAlternatives.vue?vue&type=template&id=2542e4e1&"
import script from "./TitleDeedAlternatives.vue?vue&type=script&lang=js&"
export * from "./TitleDeedAlternatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports